export default __webpack_public_path__ + "static/media/logo-rtl.3f886540.svg";